import * as React from 'react';
import { IMallPricePolicy, IMallPharmacyDetail, ISettingPharmacySource, IMallPharmacySettingInfo } from 'src/entity/MallEntity';
import { Row, Col, Select, Button } from 'antd';
import I18N from 'src/services/I18NService';
import { fetchPricePolicyByPharmacyUUID, fetchPharmacyByUUID } from 'src/redux/actions/mallPharmacyCreator';
import { pharmacyDetail2SettingInfo } from '../../redux/actions/mallPharmacyCreator';

interface IPharmacyCascaderProps {
  uniqueKey: string;
  /** 是否是编辑状态 */
  isEdit: boolean;
  /** 是否显示继承药库按钮 */
  showExtend: boolean;
  /** 是否显示删除按钮 */
  showRemove: boolean;
  /** 是否在线订购 */
  isOrderOnline: boolean;
  /** 云药房 */
  isCloud: boolean;
  /** 代理商(未开通在线订购)或配药中心（开通在线订购）生效的单元药库 */
  pharmacyList: IMallPharmacyDetail[];
  /** 传入的单元药库数据 */
  pharmacySource: ISettingPharmacySource;
  /** 本地药房下拉选项 */
  localSettingData: IMallPharmacySettingInfo[];
  /** 数据改变时回调 */
  cbPharmacyChange(data: ISettingPharmacySource): void;
  /** 删除时回调 */
  cbPharmacyRemove(key: string): void;
}

interface IPharmacyCascaderState {
  /** 价格模式列表 */
  pricePolicyList: IMallPricePolicy[];
  /** 单元药库uuid, */
  pharmacyUUID: string | undefined;
  /** 价格模式uuid */
  pricePolicyUUID: string | undefined | null;
  /** 当前单元药库详情 */
  pharmacyDetail: IMallPharmacyDetail | undefined;
  /** 继承药库 */
  isExtend: boolean;
}

class PharmacyCascader extends React.Component<IPharmacyCascaderProps, IPharmacyCascaderState> {
  constructor(props: IPharmacyCascaderProps) {
    super(props);

    this.state = {
      pricePolicyList: [],
      pharmacyUUID: undefined,
      pricePolicyUUID: undefined,
      pharmacyDetail: undefined,
      isExtend: false,
    };
  }

  async componentDidMount() {
    this.pharmacyProps2State(this.props);
  }

  async UNSAFE_componentWillReceiveProps(nextProps: IPharmacyCascaderProps) {
    this.pharmacyProps2State(nextProps);
  }

  pharmacyProps2State = async (currentProps: IPharmacyCascaderProps) => {
    const { pharmacySource } = currentProps;
    if (!!pharmacySource.medicine_group) {
      const pricePolicyList = await fetchPricePolicyByPharmacyUUID(pharmacySource.medicine_group);
      const pharmacyDetail = await fetchPharmacyByUUID(pharmacySource.medicine_group);
      this.setState({
        pharmacyUUID: pharmacySource.medicine_group,
        pricePolicyUUID: pharmacySource.medicine_price_policy,
        pricePolicyList,
        pharmacyDetail,
      });
    }
  };

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 药库数据变更时触发
   *
   * @memberof PharmacyCascader
   */
  onChangePharmacy = async (pharmacyUUID: string | undefined) => {
    const { pharmacySource, pharmacyList } = this.props;
    if (!!pharmacyUUID) {
      const pricePolicyList = await fetchPricePolicyByPharmacyUUID(pharmacyUUID);
      this.setState(
        {
          pricePolicyList,
          pharmacyUUID,
          pricePolicyUUID: null,
          pharmacyDetail: undefined,
        },
        () => {
          const pharmacyObj = pharmacyList.find((t) => t.uuid === pharmacyUUID);
          if (!!pharmacyObj) {
            this.props.cbPharmacyChange({
              uniqueKey: pharmacySource.uniqueKey,
              medicine_group: pharmacyUUID,
              medicine_price_policy: null,
              source: pharmacyDetail2SettingInfo(pharmacyObj, null),
            });
          }
        }
      );
    }
  };

  /**
   * 价格模式变更时触发
   *
   * @memberof PharmacyCascader
   */
  onChangePricePolicy = (pricePolicyUUID: string | undefined) => {
    const { pharmacySource } = this.props;
    if (!!pharmacySource) {
      this.props.cbPharmacyChange({
        uniqueKey: pharmacySource.uniqueKey,
        medicine_group: pharmacySource.medicine_group,
        medicine_price_policy: pricePolicyUUID || null,
        source: Object.assign(pharmacySource.source, {
          medicine_price_policy: pricePolicyUUID || null,
        }),
      });
    }
  };

  /**
   * 删除设置数据
   *
   * @memberof PharmacyCascader
   */
  onRemove = () => {
    this.props.cbPharmacyRemove(this.props.pharmacySource.uniqueKey);
  };

  /**
   * @description 继承药库
   * @memberof PharmacyCascader
   */
  onExtend = (isExtend: boolean) => {
    this.setState({
      isExtend,
    });
  };

  /**
   * @description 继承药库选中时触发
   * @memberof PharmacyCascader
   */
  onChangeExtendPharmacy = async (extendPharmacyUUID: string) => {
    const { pharmacySource } = this.props;
    if (!!pharmacySource.source) {
      this.props.cbPharmacyChange({
        uniqueKey: pharmacySource.uniqueKey,
        medicine_group: pharmacySource.medicine_group,
        medicine_price_policy: pharmacySource.source.medicine_price_policy,
        stocking_inherit_from: extendPharmacyUUID,
        source: pharmacySource.source,
      });
    }
  };

  render() {
    const { isEdit, pharmacyList, isCloud, showExtend, localSettingData, showRemove } = this.props;
    const { pricePolicyList, pharmacyUUID, pricePolicyUUID, pharmacyDetail, isExtend } = this.state;

    return (
      <React.Fragment>
        <Row gutter={24} style={{ margin: 0 }}>
          <Col span={4} style={{ textAlign: 'right', padding: 0 }}>
            {isEdit && <span className="colon-red">*</span>}
            {I18N.get('unit_pharmacy')}
            <span className="asterisk-black">:</span>
          </Col>
          <Col span={8} style={{ padding: 0 }}>
            <Select
              disabled={!isEdit}
              value={pharmacyUUID || undefined}
              onChange={this.onChangePharmacy}
              placeholder={`${I18N.get('common_choose')}${I18N.get('unit_pharmacy')}`}
            >
              {pharmacyList
                .filter((t) => t.uuid === pharmacyUUID || (!t.is_deleted && t.is_active))
                .map((d) => {
                  return (
                    <Select.Option key={d.seller_user} value={d.uuid} disabled={!d.is_active || !!d.is_deleted}>
                      {!!d.is_deleted ? `[${I18N.get('common_delete')}]${d.name}` : d.is_active ? d.name : `[${I18N.get('common_status_disable')}]${d.name}`}
                    </Select.Option>
                  );
                })}
              {!!pharmacyDetail && pharmacyList.findIndex((t) => t.uuid === pharmacyDetail.uuid) < 0 && (
                <Select.Option key={pharmacyDetail.seller_user} value={pharmacyDetail.uuid} disabled={true}>
                  {!!pharmacyDetail.is_deleted
                    ? `[${I18N.get('common_delete')}]${pharmacyDetail.name}`
                    : pharmacyDetail.is_active
                    ? pharmacyDetail.name
                    : `[${I18N.get('common_status_disable')}]${pharmacyDetail.name}`}
                </Select.Option>
              )}
            </Select>
          </Col>
          {pricePolicyList.length > 0 && (
            <React.Fragment>
              <Col span={4} style={{ textAlign: 'right', padding: 0 }}>
                {I18N.get('med_price_area')}
                <span className="asterisk-black">:</span>
              </Col>
              <Col span={4} style={{ padding: 0 }}>
                <Select
                  disabled={!isEdit}
                  value={pricePolicyUUID || undefined}
                  onChange={this.onChangePricePolicy}
                  placeholder={`${I18N.get('common_choose')}${I18N.get('med_price_area')}`}
                  allowClear={true}
                >
                  {pricePolicyList.map((d) => {
                    return (
                      <Select.Option key={d.uuid} value={d.uuid}>
                        {d.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
            </React.Fragment>
          )}
          <Col span={4} style={{ padding: 0 }}>
            <React.Fragment>
              {isEdit && <Button icon="minus" disabled={!showRemove} style={{ marginLeft: '8px', marginRight: '8px' }} onClick={this.onRemove} />}
              {isEdit && showExtend && !isCloud && (
                <Button type="primary" onClick={() => this.onExtend(true)} disabled={isExtend}>
                  继承药库
                </Button>
              )}
            </React.Fragment>
          </Col>
        </Row>
        {showExtend && isExtend && (
          <Row>
            <Col span={4} style={{ textAlign: 'right', padding: 0 }}>
              继承药库
              <span className="asterisk-black">:</span>
            </Col>
            <Col span={8} style={{ padding: 0 }}>
              <Select disabled={!isEdit} onChange={this.onChangeExtendPharmacy} placeholder={`${I18N.get('common_choose')}${I18N.get('unit_pharmacy')}`}>
                {localSettingData.map((d) => {
                  return (
                    <Select.Option key={d.uuid} value={d.uuid}>
                      {d.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={2} style={{ padding: 0 }}>
              <Button icon="minus" onClick={() => this.onExtend(false)} />
            </Col>
          </Row>
        )}
      </React.Fragment>
    );
  }
}

export default PharmacyCascader;



// WEBPACK FOOTER //
// ./src/components/common/PharmacyCascader.tsx